"use client";
import React, { useEffect, useState } from "react";
import { FilePond, registerPlugin } from "react-filepond";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginFileValidateSize from "filepond-plugin-file-validate-size";
registerPlugin(FilePondPluginFileValidateType, FilePondPluginFileValidateSize);
import "filepond/dist/filepond.min.css";

function UploadVerification({files,documentName="Document",setFiles,acceptedFiles=["image/*","application/pdf"],maxFileSize="10MB"}) {
  const resolvedAcceptedFileTypes =
    Array.isArray(acceptedFiles) && acceptedFiles.includes("*/*")
      ? undefined
      : acceptedFiles;

  return (
    <FilePond
      files={files}
      onupdatefiles={setFiles}
      allowMultiple={false}
      acceptedFileTypes={resolvedAcceptedFileTypes}
      maxFiles={1}
      maxFileSize={maxFileSize}
      className="my-auto"
      server={{
        url: "https://eyamweb20240304100030.azurewebsites.net/api/Upload/Document",
        process: (fieldName, file, metadata, load, error, progress, abort) => {
          const formData = new FormData();
          formData.append("file", file, file.name);
          const request = new XMLHttpRequest();
          request.open(
            "POST",
            "https://eyamweb20240304100030.azurewebsites.net/api/Upload/Document"
          );
          request.upload.onprogress = (e) => {
            progress(e.lengthComputable, e.loaded, e.total);
          };
          request.onload = function () {
            if (request.status >= 200 && request.status < 300) {
              // const response = JSON.parse(request.responseText);
              // const serverId = response.serverId; // Extract serverId from response
              // file.serverId = serverId; // Store serverId in file object
              load(request.responseText);
            } else {
              error("Error during Upload!");
            }
          };
          request.send(formData);
          return {
            abort: () => {
              request.abort();
              abort();
            },
          };
        },
      }}
      name="files"
      labelIdle={`Drag & Drop your ${documentName} or click to <span class="filepond--label-action">Browse</span>`}
    />
  );
}

export default UploadVerification;
